import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ChatMessage } from '@/types/chat';

interface ReplyContextProps {
  parentMessage: ChatMessage;
  onCancel: () => void;
}

const ReplyContext = ({ parentMessage, onCancel }: ReplyContextProps) => {
  const displayName = parentMessage.user_profile?.username || 'Unknown';
  const messagePreview = parentMessage.message.substring(0, 60) + 
    (parentMessage.message.length > 60 ? '...' : '');

  return (
    <div className="bg-muted/50 px-4 py-2 border-b border-border flex items-center justify-between">
      <div className="flex-1 min-w-0">
        <p className="text-xs text-muted-foreground">
          Replying to <span className="font-semibold text-foreground">@{displayName}</span>
        </p>
        <p className="text-xs text-muted-foreground truncate mt-0.5">
          "{messagePreview}"
        </p>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onCancel}
        className="h-6 w-6 p-0 ml-2"
      >
        <X className="h-3 w-3" />
      </Button>
    </div>
  );
};

export default ReplyContext;
